module.exports = __webpack_public_path__ + "media/images/cropper-fulltext 2-705c961fbebd2c7d994089f77c613dad.png";